<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 19.7l-7-7a5.32 5.32 0 01-1.58-3A5 5 0 018.36 4a5.37 5.37 0 013 1.57l.6.6.6-.6a5.31 5.31 0 013-1.57 5 5 0 014.21 1.43 5 5 0 011.43 4.21 5.32 5.32 0 01-1.58 3l-7 7a1 1 0 01-1.34.06zM7.71 6.05a3 3 0 00-2.11 5.08l6.4 6.4 6.4-6.4a3 3 0 000-4.21 3.06 3.06 0 00-4.21 0L12 9.11 9.81 6.92a3 3 0 00-2.1-.87z"/></svg>